import request from '../../utils/request'
import config from '../../../config/config'
// const baseURL = 'http://localhost:3013'
const baseURL = config.baseUrl;

//  信息新增
export function noticeAdd (data) {
  return request({
    url: baseURL + 'notice/add',
    method: 'post',
    data: data
  })
}
//  信息查询
export function noticeList (data) {
  return request({
    url: baseURL + 'notice/list',
    method: 'post',
    data: data
  })
}
//  信息删除
export function noticeDelete (data) {
  return request({
    url: baseURL + 'notice/delete',
    method: 'post',
    data: data
  })
}
//  信息删除
export function noticeUpdate (data) {
  return request({
    url: baseURL + 'notice/update',
    method: 'post',
    data: data
  })
}




// WEBPACK FOOTER //
// ./src/api/notice/index.js